import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {CyClass} from "../../../../../../../common/cy-classes";
import React from "react";
import {GameHeaderBarCloseButtonBox} from "../../boxes/close-game-button/game-header-bar-close-button.box";

interface GameHeaderBarCloseGameButtonComponentProps {
    gameType?: number;
}

export const GameHeaderBarCloseGameButtonComponent = observer(class GameHeaderBarCloseGameButtonComponent extends OrbitComponent<GameHeaderBarCloseGameButtonComponentProps> {
    private _onClickHandler = async () => {
        this.services.analytics.sendOrbitUserFlowEvent('X_to_close', 'Close', 'X_to_close', this.props.gameType || '');

        await (await this.services.gameRunner).currentRunningGame?.closeGame({
            shouldSuggestNextGame: true
        });
    }

    render() {
        return (
            <GameHeaderBarCloseButtonBox onClick={this._onClickHandler} className={CyClass('cy-game-navbar-close-button')}/>
        );
    }
});